import {
  LoadCourseDetailAsync,
  LoadCourseInstancesForLastLoadedDetailAsync,
  ShowMyCartSummaryAsync,
  MarkCoursesOccupancyAsync,
  MarkMyCoursesAsync,
} from './aka.js';
import { getUrlParameter } from './shared/utils';
export async function mainkurz() {
  const id = getUrlParameter('id').toString();
  console.log('load course ' + id);
  await LoadCourseDetailAsync(id);
  await LoadCourseInstancesForLastLoadedDetailAsync();
  await MarkCoursesOccupancyAsync();
  await MarkMyCoursesAsync();
  await ShowMyCartSummaryAsync();
}
